export const LOAD_WORKSPACE_ACCOUNTS = "LOAD_WORKSPACE_ACCOUNTS";
export const SET_WORKSPACE_ACCOUNTS = "SET_WORKSPACE_ACCOUNTS";
export const SET_WORKSPACE_ACCOUNTS_ERROR = "SET_WORKSPACE_ACCOUNTS_ERROR";
export const LOAD_SPECIFIC_ACCOUNT = "LOAD_SPECIFIC_ACCOUNT";
export const SET_SPECIFIC_ACCOUNT = "SET_SPECIFIC_ACCOUNT";
export const SET_SPECIFIC_ACCOUNT_LOAD_ERROR = "SET_SPECIFIC_ACCOUNT_LOAD_ERROR";
